import React from 'react'

type IconProps = {
    size?: number
    className?: string
}

const Svg = ({
    children,
    size = 20,
    className,
}: React.PropsWithChildren<IconProps>) => (
    <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="currentColor"
        className={className}
    >
        {children}
    </svg>
)

// ─────────────────────────────────────────────
// Horizontal alignment
// ─────────────────────────────────────────────

export const AlignLeftIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="4" y="4" width="2" height="16" />
        <rect x="8" y="7" width="12" height="2" />
        <rect x="8" y="15" width="8" height="2" />
    </Svg>
)

export const AlignCenterIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="11" y="4" width="2" height="16" />
        <rect x="5" y="7" width="14" height="2" />
        <rect x="7" y="15" width="10" height="2" />
    </Svg>
)

export const AlignRightIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="18" y="4" width="2" height="16" />
        <rect x="4" y="7" width="12" height="2" />
        <rect x="8" y="15" width="8" height="2" />
    </Svg>
)

// ─────────────────────────────────────────────
// Vertical alignment
// ─────────────────────────────────────────────

export const AlignTopIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="4" y="4" width="16" height="2" />
        <rect x="7" y="8" width="2" height="12" />
        <rect x="15" y="8" width="2" height="8" />
    </Svg>
)

export const AlignMiddleIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="4" y="11" width="16" height="2" />
        <rect x="7" y="5" width="2" height="14" />
        <rect x="15" y="7" width="2" height="10" />
    </Svg>
)

export const AlignBottomIcon = (props: IconProps) => (
    <Svg {...props}>
        <rect x="4" y="18" width="16" height="2" />
        <rect x="7" y="4" width="2" height="12" />
        <rect x="15" y="8" width="2" height="8" />
    </Svg>
)
